
(function ($) {

    // DOM cache
    var html = $("html");
    var body = $("body");

    $.controls = {};

    var dialogOpenCallback = null;
    var dialogCloseCallback = null;

    function updateCheckDiv(check) {
        if (check.prop("checked") == true)
            check.parent().addClass("ui-checked");
        else
            check.parent().removeClass("ui-checked");
    }

    function updateRadioDiv(check) {
        if (check.prop("checked") == true) {
            var radioName = check.attr("name");

            $("label.ui-radio.ui-checked > input[type=radio][name='" + radioName + "']").each(function () {
                $(this).parent().removeClass("ui-checked");
            });

            check.parent().addClass("ui-checked");
        } else {
            check.parent().removeClass("ui-checked");
        }
    }

    $.fn.checkbox = function (options, value) {
        if (options == undefined || typeof options == "object") {
            var settings = $.extend({
                'checkediconname': 'done'
            }, options);

            return this.each(function () {
                var parent = $(this).parent();
                var checkbox = $("<div><div><i class='material-icons'>" + settings.checkediconname + "</i></div></div>");

                parent.addClass("ui-checkbox");
                $(this).after(checkbox);

                $(this).on('change', function () {
                    updateCheckDiv($(this));
                });

                updateCheckDiv($(this));
            });
        } else if (options === 'update') {
            updateCheckDiv($(this));
        }
        else if (options === 'destroy') {

            $(this).next('div').remove();
        }
    };

    $.fn.radio = function (options, value) {
        if (options == undefined || typeof options == "object") {
            var settings = $.extend({

            }, options);


            return this.each(function () {
                var parent = $(this).parent();
                var radio = $("<div><div></div></div>");

                parent.addClass("ui-radio");
                parent.append(radio);

                $(this).change(function () {
                    updateRadioDiv($(this));
                });

                updateRadioDiv($(this));
            });
        }
    };

    $.fn.checkButton = function (options, value) {
        return this.each(function () {
            $(this).click(function () {
                $(this).toggleClass("active");
            });
        });
    };

    $.fn.checkButtonGroup = function (options, value) {
        return this.each(function () {
            $(this).children(".btn").click(function () {
                $(this).addClass("active").siblings().removeClass("active");
            });
        });
    };

    $.fn.input = function (options, value) {
        if (options == undefined || typeof options == "object") {
            var settings = $.extend({

            }, options);

            return this.each(function () {
                var placeholder = $(this).attr("placeholder");
                if (placeholder) {

                    // Wrap the input
                    $(this).wrap("<div class='ui-input'></div>");

                    // Get values
                    var that = $(this);
                    var parent = $(this).parent();

                    // Remove placeholder
                    $(this).attr("placeholder", "");
                    $(this).prop("placeholder", "");

                    parent.append("<span class='placeholder'>" + placeholder + "</span>");
                    parent.css("margin-bottom", $(this).css("margin-bottom"));
                    $(this).css("margin-bottom", 0);

                    $(this).focus(function () { parent.addClass("filled"); });
                    $(this).blur(function () { if (that.val() == "") parent.removeClass("filled"); });
                    $(this).change(function () {
                        if (that.val() == "")
                            parent.removeClass("filled");
                        else
                            parent.addClass("filled");
                    });

                    $(this).change();
                }
            });
        }
    };

    $.fn.numericInput = function (options, value) {
        return this.each(function () {
            var oldInput = "";
            var fired = false;

            $(this).attr("type", "text");

            $(this).keydown(function () {
                if (fired) return;

                oldInput = $(this).val();
                fired = true;
            });

            $(this).keyup(function () {
                var value = $(this).val();

                if (/^[\-]?\d*[.]?\d*$/.test(value) == false) {
                    $(this).val(oldInput);
                } else {
                    oldInput = value;
                }

                fired = false;
            });

            // Wrap container
            $(this).wrap("<div class='ui-numeric-input " + (options == undefined || options.className == undefined ? "" : options.className) + "'</div>");
            $(this).parent().append(
                "<i class='arrow up material-icons'>keyboard_arrow_up</i>" +
                "<i class='arrow down material-icons'>keyboard_arrow_down</i>");


            $(this).parent().children(".arrow.up").on('click', function () {
                var step = $(this).attr("step") ? parseFloat($(this).attr("step")) : 1;
                var decimalValues = step.toString().indexOf(".") == -1 ? 0 : step.toString().substr(step.toString().indexOf(".") + 1).length;

                var that = $(this).closest(".ui-numeric-input").children("input");
                var value = that.val() != "" ? parseFloat(that.val()) : 0;
                value += step;

                that.val(value.toFixed(decimalValues));
                that.trigger('change');

            });

            $(this).parent().children(".arrow.down").on('click', function () {
                var step = $(this).attr("step") ? parseFloat($(this).attr("step")) : 1;
                var decimalValues = step.toString().indexOf(".") == -1 ? 0 : step.toString().substr(step.toString().indexOf(".") + 1).length;

                var that = $(this).closest(".ui-numeric-input").children("input");
                var value = that.val() != "" ? parseFloat(that.val()) : 0;
                value -= step;

                that.val(value.toFixed(decimalValues));
                that.trigger('change');
            });

            $(this).on('change', function () {
                var min = $(this).attr("min");
                var max = $(this).attr("max");

                var oldValue = $(this).val() != "" ? parseFloat($(this).val()) : "";
                var newValue = oldValue;

                if (oldValue === "")
                    return;

                if (max !== undefined && oldValue >= max)
                    newValue = max;

                if (min !== undefined && oldValue <= min)
                    newValue = min;

                if (Math.abs(oldValue - newValue) > Number.EPSILON) {
                    $(this).val(newValue);
                    // Trigger again the change
                    $(this).trigger('change');
                }
            });
        });
    };

    $.fn.combobox = function (options, value) {
        var that = this;

        function _updateSelectedItemView(el, item) {

            let data = el.data("data");
            if (!data || !item)
                return;

            if (item.length > 0) {
                data._container.children(".ui-select-current-value").html(item.html()).removeClass("ui-select-placeholder");
            } else {
                data._container.children(".ui-select-current-value").html(data.placeholder).addClass("ui-select-placeholder");
            }
        }

        // Set value
        function _setValue(el, item) {

            let data = el.data("data");
            if (!data || !item)
                return;

            _updateSelectedItemView(el, item);

            data.value = item.length > 0 ? item.data("value") : null;
            el.val(data.value);
            return data.value;
        }

        function _findItemByValue(el, value) {

            let data = el.data("data");
            if (!data)
                return;

            return data._dropdown.find(".ui-select-item").filter(function () {
                return $(this).data("value") == value;
            });
        }


        // Resize
        function resize() {
            // Check if this selecte exist
            that.combobox("refreshLayout");
        }

        if (options == undefined || typeof options == "object") {
            var settings = $.extend({
                placeholder: "",
                classes: "",
                searcheable: false,
                placeholdersearchtext: 'Search',
                container: null,
                lazy: false
            }, options);

            return this.each(function () {
                var that = $(this);

                var data = {
                    value: null,
                    placeholder: settings.placeholder,
                    _container: null,
                    _dropdown: null,
                    lazy: settings.lazy
                };

                if ($(this).data("data"))
                    $(this).combobox("destroy");

                // Hide the original select
                $(this).hide();

                // Attach object
                $(this).data("data", data);

                // Create the new select
                $(this).wrap("<div class='ui-select' />");
                var container = $(this).parent();

                // Add label
                if (settings.searcheable !== true)
                    container.append("<span class='ui-select-current-value'>" + data.placeholder + "</span>");

                // Add arrow
                container.append("<i class='ui-select-arrow material-icons'>keyboard_arrow_down</i>");

                /// Add dropdown
                var dropdown = $("<div class='ui-select-dropdown'/>");
                dropdown.appendTo(settings.container == null ? $(document.body) : settings.container);
                dropdown.on("click", function (e) {
                    e.stopPropagation();
                });

                if ($.fn.perfectScrollbar)
                    dropdown.perfectScrollbar();

                // Item list
                var itemsList = $("<ul class='ui-select-items-list'/>");
                itemsList.appendTo(dropdown);

                // Add textbox for search
                if (settings.searcheable === true) {

                    container.addClass('searcheable');
                    var textboxSearch = $('<input type="text" class="searchtextbox form-control" placeholder="' + settings.placeholdersearchtext + '" />');
                    textboxSearch.appendTo(container);

                    textboxSearch.on("input change", _.debounce(function () {
                        var filter = $(this).val();
                        var comboElements = dropdown.find("ul.ui-select-items-list li");

                        if (!filter)
                            comboElements.show();

                        comboElements.hide().each(function () {
                            if ($(this).html().toLowerCase().indexOf(filter.toLowerCase()) != -1)
                                $(this).show();
                        });

                        that.combobox("open");
                    }));

                    textboxSearch.on('click', function (e) {
                        // If readonly, open combobox
                        if (that.attr("readonly") == "readonly") {
                            that.combobox("open");
                        }   
                    });
                }

                // Item click
                dropdown.on("click", ".ui-select-item", function (e) {
                    var value = _setValue(that, $(this));

                    if (settings.searcheable === true) {
                        var textboxSearch = container.find('input.searchtextbox');
                    }

                    // Close menu and trigger change
                    that.combobox("close");
                    that.trigger("change", value);

                    e.stopPropagation();
                });

                // Dropdown open/close
                container.on('click', function (e) {

                    if (settings.searcheable === true) {
                        var textboxSearch = dropdown.find('input.searchtextbox');
                        textboxSearch.val('').trigger('change');
                    }

                    if ($(this).attr("disabled") == "disabled")
                        return;

                    if (container.hasClass("opened")) {
                        that.combobox("close");
                    } else {
                        that.combobox("open");
                    }

                    e.stopPropagation();
                });

                // On body click close
                $(document.body, settings.container).click(function (e) {

                    if (settings.searcheable === true) {
                        var textboxSearch = dropdown.find('input.searchtextbox');
                        textboxSearch.val('').trigger('change');
                    }

                    that.combobox("close");
                });

                $(this).data("cbResize", () => $(this).combobox("refreshLayout"));
                $(document.body).on("ps-scroll-y ps-scroll-x", $(this).data("cbResize"));

                // Custom classes
                dropdown.addClass(settings.classes);
                container.addClass(settings.classes);

                // Cache
                data._container = container;
                data._dropdown = dropdown;

                $(this).combobox("refreshLayout");
                $(this).combobox("refreshItems");
                $(this).combobox("value", $(this).val());
            });
        } else {
            if (options == "refreshLayout") {
                return this.each(function () {
                    var data = $(this).data("data");
                    if (!data || !data._dropdown)
                        return;

                    var _parent = data._dropdown.parent();

                    data._dropdown.css("left", (data._container.offset().left + (_parent ? _parent.scrollLeft() : 0) - _parent.offset().left) + "px");
                    data._dropdown.css("width", data._container.outerWidth() + "px");

                    if ($(this).attr("disabled"))
                        data._container.attr("disabled", "disabled");
                    else
                        data._container.removeAttr("disabled");

                    if ($(this).attr("readonly"))
                        data._container.attr("readonly", "readonly");
                    else
                        data._container.removeAttr("readonly");
                });
            } else if (options == "refreshItems") {
                return this.each(function () {
                    var data = $(this).data("data");
                    var itemsList = data._dropdown.children(".ui-select-items-list");
                    itemsList.empty();

                    // Add items
                    $(this).children("option").each(function (index) {

                        // Add index
                        if (!$(this).attr("value"))
                            $(this).attr("value", $(this).val());

                        // Get template
                        let loadTemplate = !data.lazy || (data.lazy && value);

                        let template = (loadTemplate && $(this).data("template")) ? $(this).data("template") : $(this).text();
                        let visible = $(this).data("visible") == undefined || $(this).data("visible") == null || $(this).data("visible") == true ? true : false;
                        let html = null;

                        if ($(this).hasClass("label")) {
                            html = $("<li class='ui-select-label'>" + template + "</li>");
                            html.on('click', function (e) {
                                e.stopPropagation();
                            });

                        } else {
                            html = $("<li class='ui-select-item' data-index='" + index + "'></li>");
                            html.data("value", $(this).val());
                            html.html(template);
                        }


                        itemsList.append(html);

                        if (!visible)
                            html.hide();
                    });

                    // Update value template
                    _updateSelectedItemView($(this), _findItemByValue($(this), $(this).combobox("value")));

                });
            } else if (options == "open") {

                // Close others
                $("select").combobox("close");

                return this.each(function () {
                    var that = $(this);
                    var data = $(this).data("data");
                    if (!data) return;

                    $(this).combobox("refreshLayout");

                    data._container.addClass("opened");
                    data._dropdown.addClass("opened");

                    // Get first item
                    var height = Math.min(300, data._dropdown.find(".ui-select-items-list").outerHeight());
                    data._dropdown.height(height);

                    if (data._container.offset().top + data._container.outerHeight() + height > window.innerHeight)
                        data._dropdown.css("bottom", (window.innerHeight - data._container.offset().top) + "px");
                    else
                        data._dropdown.css("top", (data._container.offset().top + data._container.outerHeight()) + "px");
                });
            } else if (options == "close") {
                return this.each(function () {
                    var data = $(this).data("data");
                    if (!data) return;

                    // Check if already closed
                    if (data._container.hasClass("opened") == false)
                        return;

                    // Remove classes
                    data._container.removeClass("opened");
                    data._dropdown.removeClass("opened");
                    data._dropdown.height(0);

                    // Reset scroll
                    setTimeout(function () {
                        data._dropdown.scrollTop(0);
                    }, 300);

                });
            } else if (options == "value") {

                if (value === undefined) {
                    var first = this.first();
                    var data = first.data("data");
                    if (!data) return;

                    return data.value;
                } else {
                    return this.each(function () {
                        var data = $(this).data("data");
                        if (!data) return;

                        var item = _findItemByValue($(this), value);

                        _setValue($(this), item);
                    });
                }

            } else if (options == "destroy") {
                return this.each(function () {
                    var data = $(this).data("data");
                    if (!data) return;

                    $(this).siblings().remove().end().unwrap().show();
                    data._dropdown.remove();
                    $(document.body).off("ps-scroll-y ps-scroll-x", $(this).data("cbResize"));
                });
            }
        }

    }

    $.fn.dataGrid = function (options, value) {

        // Methods
        function resize(el) {
            var settings = el.data("settings");

            if (settings.aspectRatio != null) {
                var items = el.children("li");
                var ratio = settings.aspectRatio;

                items.each(function () {
                    var width = $(this).outerWidth();
                    $(this).outerHeight(width / ratio);
                });
            }
        }

        function requestData(el) {
            var grid = el.data("grid");
            var settings = el.data("settings");

            if (grid.loading == true) return;
            grid.loading = true;

            var data = {
                start: (grid.currentPage - 1) * settings.pageLength,
                length: settings.pageLength,
                search: {
                    value: grid.filter
                }
            };

            // Custom data
            if (settings.customData)
                $.extend(data, settings.customData);

            $.ajax({
                url: settings.url,
                method: "get",
                type: "json",
                data: data
            }).done(function (response) {
                for (var i = 0; i < 1; i++) {

                    grid.data = response.data;

                    // Append all items
                    if (response.data.length == 0) {
                        grid.finish = true;
                    } else {
                        $.each(response.data, function (i, data) {
                            var item = $("<li data-id='" + data.id + "'><span class='check'><i class='material-icons'>check</i></span></li>");
                            item.data("data", data);

                            var content = settings.template(data);
                            content.appendTo(item);
                            item.appendTo(el);

                            // If is a selected item, re-select it
                            if (data.id)
                                if (_.findWhere(grid.selectedItems, { id: data.id })) {
                                    item.click();
                                }
                        });

                    }
                }


                for (i = 0; i < 10; i++) {
                    el.append("<div class='flex-fix'></div>");
                }

                // Re-adapt items width
                resize(el);

                // Move to next page
                grid.currentPage++;
            }).fail(function (response) {

            }).always(function () {
                grid.loading = false;
            });
        }

        function scroll(el) {

            var grid = el.data("grid");
            if (grid.finish || grid.loading) return;

            var scroll = body.scrollTop();
            var height = body.height();
            var pageHeight = $(window).height();

            // If we scrolled in the second last page
            if (scroll > height - pageHeight * 2) {
                requestData(el);
            }

        }

        // Get values
        if (options == "val") {
            var dataGrid = this.first();
            if (dataGrid == null) return null;
            var grid = dataGrid.data("grid");

            if (!value) {
                var ids = [];
                $.each(grid.selectedItems, function (i, d) {
                    ids.push(parseInt(d.id));
                });

                return ids;
            } else {
                var values = value instanceof Array ? value : [value];

                grid.selectedItems.length = 0;
                dataGrid.find("li").removeClass("selected");

                $.each(values, function (i, v) {
                    $.each(grid.data, function (i2, d) {
                        if (d.id == v) {

                            grid.selectedItems.push(d);
                            dataGrid.find("li[data-id=" + v + "]").addClass("selected");
                        }
                    });
                })
            }
        } else if (options == "valObj") {
            var dataGrid = this.first();
            if (dataGrid == null) return null;
            var grid = dataGrid.data("grid");

            return grid.selectedItems;
        }

        return this.each(function () {
            var grid;
            var settings;

            if (options == undefined || typeof options == "object") {
                settings = $.extend({
                    url: null,
                    local: false,
                    click: null,
                    template: null,
                    customData: null,
                    pageLength: 20,
                    page: 1,
                    aspectRatio: null,
                    minWidth: 100,
                    paginate: true,
                    selection: false,
                    multiple: false,
                    filter: ""
                }, options);

                if (!settings.local) {
                    if (!settings.template) {
                        console.error("Please define a template function");
                        return;
                    }

                    if (!settings.url) {
                        console.error("Please define a url");
                        return;
                    }
                }

                var that = $(this);
                grid = {
                    loading: false,
                    finish: false,
                    currentPage: settings.page,
                    filter: settings.filter,
                    selectedItems: []
                };

                $(this).data("grid", grid);
                $(this).data("settings", settings);
                $(this).addClass("ui-data-grid");

                if (!settings.local) {
                    requestData($(this));

                    if (settings.paginate)
                        $(window).scroll(function () {
                            scroll(that);
                        });
                } else {

                    // Flex fix
                    for (var i = 0; i < 10; i++) {
                        $(this).append("<div class='flex-fix'></div>");
                    }
                }

                // Item click
                $(this).on("click", "li", function (e) {
                    var data = $(this).data("data");

                    if (settings.selection == true) {
                        if (settings.multiple == false)
                            that.find("li").removeClass("selected");

                        $(this).toggleClass("selected");

                        if ($(this).hasClass("selected")) {
                            grid.selectedItems.push(data);
                        } else {
                            Array.remove(grid.selectedItems, data);
                        }
                    }

                    if (settings.click) {
                        settings.click(data);
                    }
                });

                $(window).resize(function () {
                    resize(that)
                });

                resize(that);
            } else {
                grid = $(this).data("grid");
                settings = $(this).data("settings");

                if (options == "clear") {
                    $(this).empty();
                    grid.currentPage = 1;
                } else if (options == "refresh") {
                    $(this).empty();

                    grid.currentPage = 1;
                    requestData($(this));
                } else if (options == "customData") {
                    settings.customData = value;
                } else if (options == "filter") {
                    grid.filter = value;
                } else if (options == "deselect") {
                    Array.remove(grid.selectedItems, value);
                    $(this).find("li[data-id=" + value.id + "]").removeClass("selected");
                } else if (options == "select") {
                    grid.selectedItems.push(value);
                    $(this).find("li[data-id=" + value.id + "]").addClass("selected");
                }
            }
        });
    };

    $.fn.dialog = function (options, value) {

        // Mobile media query
        var mq = window.matchMedia("(max-width: 768px)");

        var modalTemplate =
            "<div class='valign'>" +
            "<div class='modal-dialog'>" +
            "<div class='modal-content'>" +
            "<div class='modal-header'>" +
            "<div class='icon'><i class='material-icons'>%icon%</i></div>" +
            "<button type='button' class='close' data-dismiss='modal' aria-label='Close'><span aria-hidden='true'>&times;</span></button>" +
            "</div>" +
            "<div class='modal-body'>" +
            "</div>" +
            "<div class='modal-footer'>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>";

        if (options == undefined || typeof options == "object") {

            return this.each(function () {
                var that = $(this);

                // Move the dialog in the body
                that.appendTo($(document.body));

                var settings = $.extend({
                    icon: null,
                    iconType: "vector",
                    headerType: "big",
                    style: "predefined-dialog",
                    buttonsAlign: "center",
                    buttons: {},
                    closeCallback: null
                }, options);

                if (options == undefined || typeof options == "object") {
                    $(this).data("settings", settings);

                    // Build the dialog

                    // 1) classes and attributes
                    $(this).addClass("modal fade " + settings.style);
                    $(this).attr("role", "dialog");

                    // 2) dom
                    var content = $(this).children("*");
                    var container = $(modalTemplate.replace("%icon%", settings.icon));

                    // Remove icon if empty
                    if (!settings.icon || settings.icon == "")
                        container.find(".modal-header > .icon").remove();

                    if (settings.iconType == "raster")
                        container.find(".icon > i").replaceWith("<img src='" + settings.icon + "' alt='' />");

                    if (settings.headerType == "small")
                        container.find(".modal-header").addClass("small");

                    content.appendTo(container.find(".modal-body"));
                    container.appendTo($(this));

                    $(this).find(".modal-dialog").click(function (e) {
                        e.stopPropagation();
                    });

                    if ($.fn.perfectScrollbar)
                        $(this).perfectScrollbar();

                    // 3) buttons
                    var footer = container.find(".modal-footer");
                    footer.addClass("text-" + settings.buttonsAlign);
                    if (settings.buttons instanceof Array) {
                        $.each(settings.buttons, function (i, btn) {

                            var dom = $("<button type='button'><span>" + btn.label + "</span></button>");

                            if (btn.dataTrack)
                                dom.attr("data-track", btn.dataTrack);

                            if (btn.outline)
                                dom.addClass("btn-outline");

                            if (btn.hasLoading)
                                dom.append($("<img class='button-loading' src='/images/other/loading.gif' alt='' />"))

                            if (btn.func == null) {
                                dom.click(function () {
                                    that.dialog("hide");
                                });
                            } else {
                                dom.click(function () {
                                    btn.func.apply(dom);
                                });
                            }

                            footer.append(dom);
                        });
                    } else {
                        $.each(settings.buttons, function (label, func) {
                            var dom = $("<button type='button'>" + label + "</button>");

                            if (func == null) {
                                dom.click(function () {
                                    that.dialog("hide");
                                });
                            } else {
                                dom.click(function () {
                                    func.apply(dom);
                                });
                            }

                            footer.append(dom);

                        });
                    }

                    // 4) combobox close fix
                    $(this).find(".modal-dialog").click(function () {
                        $("select").combobox("close");
                    });

                    // 5) close
                    $(this).find(".close").click(function () {
                        if (settings.closeCallback)
                            settings.closeCallback();
                        else
                            that.dialog("hide");
                    });

                    //$(this).click(function () {
                    //    $(this).dialog("hide");
                    //});
                }
            });
        } else if (options == "show") {
            this.each(function () {
                if ($(this).hasClass("opened"))
                    return;

                var that = $(this);
                $(this).show();
                $(this).removeClass("closed");
                $(this).appendTo($(document.body)); // Move after all other dialogs

                setTimeout(function () {
                    that.addClass("opened");
                    that.trigger("dialog.show");

                    $(document.body).css("overflow", "hidden");

                    if (dialogOpenCallback)
                        dialogOpenCallback();

                    // Value as callback
                    if (value)
                        value();
                }, 5);
            });
        } else if (options == "hide") {
            this.each(function () {
                if (!$(this).hasClass("opened"))
                    return;

                var that = $(this);
                $(this).removeClass("opened");
                $(this).addClass("closed");

                setTimeout(function () {
                    that.trigger("dialog.hide");
                    that.hide();

                    $(document.body).css("overflow", "auto");

                    if (dialogCloseCallback)
                        dialogCloseCallback();

                    // Value as callback
                    if (value)
                        value();
                }, 500);
            });
        }
    }

    $.controls.dialog = function (options, value) {
        if (options == "openCallback") {
            dialogOpenCallback = value;
        } else if (options == "closeCallback") {
            dialogCloseCallback = value;
        }
    };

}(jQuery));